import React, { useState } from 'react';
import { Alert } from 'antd';
import { FaClock } from 'react-icons/fa';
import { useLanguage } from '../../context/LanguageContext';

export default function TimeSlotSelect({ selectedDate, workingDay, onSelect, selectedSlot }) {
    const { t } = useLanguage();
    const [error, setError] = useState('');

    const handleSlotSelect = (slot) => {
        setError('');
        onSelect(slot);
    };

    const formatTime = (timeStr) => {
        if (!timeStr || typeof timeStr !== 'string') return '';
        const [hour, minute] = timeStr.split(':');
        const hourNum = parseInt(hour, 10);
        if (isNaN(hourNum)) return timeStr;
        const ampm = hourNum >= 12 ? t('timeSlotSelect.pm') : t('timeSlotSelect.am');
        const formattedHour = hourNum % 12 || 12;
        return `${formattedHour}:${minute} ${ampm}`;
    };

    const isTimeSlotPassed = (slot) => {
        if (!selectedDate || !slot.endTime) return false;
        
        const today = new Date();
        const selectedDateObj = new Date(selectedDate);
        
        const isToday = today.getFullYear() === selectedDateObj.getFullYear() &&
                       today.getMonth() === selectedDateObj.getMonth() &&
                       today.getDate() === selectedDateObj.getDate();
        
        if (!isToday) return false;
        
        const [hour, minute] = slot.endTime.split(':').map(num => parseInt(num, 10));
        
        const slotEndTime = new Date();
        slotEndTime.setHours(hour, minute, 0, 0);
        
        return today > slotEndTime;
    };



    if (!workingDay || !workingDay.isWorking || !workingDay.availabilityHours || workingDay.availabilityHours.length === 0) {
        return <Alert message={t('timeSlotSelect.noAvailability')} type="warning" showIcon />;
    }

    return (
        <div className="space-y-2">
            {error && <Alert message={error} type="error" showIcon className="mb-4" />}

            <h2 className="text-xl font-semibold text-textPrimary flex items-center gap-2">
                <FaClock className="text-primary" />
                {t('timeSlotSelect.title')}
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {workingDay.availabilityHours.map((slot) => {
                    const startFormatted = formatTime(slot.startTime);
                    const endFormatted = formatTime(slot.endTime);
                    const isSelected = selectedSlot?.availabilityHourId === slot.availabilityHourId;
                    const isPassed = isTimeSlotPassed(slot);

                    return (
                        <button
                            key={slot.availabilityHourId}
                            onClick={() => !isPassed && handleSlotSelect(slot)}
                            disabled={isPassed}
                            className={`
                                h-14 rounded-lg border
                                font-medium text-base
                                transition duration-200 ease-in-out
                                focus:outline-none focus:ring-2 focus:ring-primary
                                ${isPassed
                                    ? 'bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed'
                                    : isSelected
                                        ? 'bg-primary text-white border-primary'
                                        : 'bg-white text-textPrimary border-placeHolder hover:border-primary hover:bg-gray-100'
                                }
                            `}
                        >
                            {startFormatted && endFormatted
                                ? `${startFormatted} - ${endFormatted}`
                                : t('timeSlotSelect.invalidTime')}
                            {isPassed && (
                                <span className="block text-xs mt-1 text-gray-400">
                                    {t('timeSlotSelect.timePassed')}
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}